import { Routes, Route, Navigate } from "react-router-dom";

// import Distributions from "./Distributions";
import CustomsBokerages from "./CustomsBokerages";

const customsBokeragesRoutes = [
    {routeName: 'airport-customs' , component: <CustomsBokerages/>},
    {routeName: 'border-customs' , component: <CustomsBokerages/>},
    {routeName: 'seaport-customs' , component: <CustomsBokerages/>},
    {routeName: 'documentations' , component: <CustomsBokerages/>},
               
];

const CustomsBokeragesRoutes = () => {
    return (
    <Routes>
       {customsBokeragesRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default CustomsBokeragesRoutes;